import { render, staticRenderFns } from "./settleManage.vue?vue&type=template&id=35360eb4&"
import script from "./settleManage.vue?vue&type=script&lang=js&"
export * from "./settleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports